/**
 * Routes served by the workeffy SPA (effy-fe), mounted under the `/w` basename.
 * These are not Next.js pages — crossing into them needs a full page load.
 * Keep in sync with `workeffyRoutes` in effy-fe.
 */
export const WORKEFFY_BASENAME = '/w';

export const isWorkeffyPath = (path: string) =>
  path === WORKEFFY_BASENAME || path.startsWith(`${WORKEFFY_BASENAME}/`);

export type OnboardingFlow = 'f_adm' | 'co_adm' | 'employee' | 'b2c';

/** Keep in sync with `ONBOARDING_STEP_ORDERS` in effy-fe's `onboarding-paths.ts`. */
const workeffyOnboardingRoutes = {
  WorkeffyOnboarding: (flow: OnboardingFlow) => `${WORKEFFY_BASENAME}/onboarding/${flow}`,
};

const workeffyAdminRoutes = {
  WorkeffyCompanyProfile: (tab?: string) =>
    `${WORKEFFY_BASENAME}/admin/settings/company-profile${tab ? `/${tab}` : ''}`,
  WorkeffyOrgStructure: () => `${WORKEFFY_BASENAME}/admin/org-setup/manual`,
  WorkeffyLocations: () => `${WORKEFFY_BASENAME}/admin/locations`,
  WorkeffyJobArchitecture: () => `${WORKEFFY_BASENAME}/admin/job-architecture`,
  WorkeffyCareerPaths: () => `${WORKEFFY_BASENAME}/career-paths`,
  WorkeffyOrgSetup: () => `${WORKEFFY_BASENAME}/admin/org-setup`,
  WorkeffyActions: () => `${WORKEFFY_BASENAME}/admin/automate/actions`,
  WorkeffyAgents: () => `${WORKEFFY_BASENAME}/admin/agents`,
  WorkeffyMgsa: () => `${WORKEFFY_BASENAME}/admin/settings/mgsa`,
  WorkeffyPeopleDirectory: () => `${WORKEFFY_BASENAME}/people-directory`,
  WorkeffyPermissions: () => `${WORKEFFY_BASENAME}/admin/permissions`,
  WorkeffyFieldOptions: () => `${WORKEFFY_BASENAME}/admin/settings/field-options`,
  WorkeffyAdminIntegrations: () => `${WORKEFFY_BASENAME}/admin/integrations`,
};

const workeffyAccountRoutes = {
  WorkeffyEditProfile: () => `${WORKEFFY_BASENAME}/profile/edit`,
  WorkeffyIntegrations: () => `${WORKEFFY_BASENAME}/integrations`,
};

// Mirrors effy-fe's ROUTES.mgsa.Documents / DocumentsForYou / DocumentsManage.
const workeffyDocumentsRoutes = {
  WorkeffyDocuments: () => `${WORKEFFY_BASENAME}/documents/libraries`,
  WorkeffyDocumentsForYou: () => `${WORKEFFY_BASENAME}/documents/for-you`,
  WorkeffyDocumentsManage: () => `${WORKEFFY_BASENAME}/documents/manage`,
};

const routes = {
  ...workeffyAdminRoutes,
  ...workeffyAccountRoutes,
  ...workeffyOnboardingRoutes,
  ...workeffyDocumentsRoutes,
};

export default routes;
